/* inno-boot.js — Innocences archive-terminal boot.
   Plays once per session, top-left, over an opaque backdrop while the wave waits behind. Lines
   come in LINE-BY-LINE (not char-by-char); some decode via a character scramble (SCR, the
   wordmark's charset). Every readout is real: the archive's own counts, the visitor's bag, Toronto
   date and weather, and a loading bar that measures actual work. Anyone who has sat through it
   before gets a short version. Click / tap / Enter / Esc skips. */
(function () {
  'use strict';

  var boot = document.getElementById('inno-boot');
  var out = document.getElementById('inno-boot-output');
  var hint = document.getElementById('inno-boot-hint');
  if (!boot || !out) return;

  // ONCE PER SESSION, first load only. The completion flag (`inno_booted`) is written in
  // finalize(), so an interrupted intro — reload, deep link, tapping away mid-sequence — used to
  // replay it on the next page. A separate marker is written the moment the intro STARTS, so it
  // can only ever run on the session's first load.
  var seen = false;
  try { seen = !!(sessionStorage.getItem('inno_booted') || sessionStorage.getItem('inno_boot_seen')); } catch (e) {}
  if (seen) {
    boot.style.display = 'none';
    // downstream code (the field's BIOS-active checks, the page loader) reads `inno_booted` to mean
    // "the intro is not on screen" — set it here too so a skipped intro is treated as finished
    try { sessionStorage.setItem('inno_booted', '1'); } catch (e) {}
    return;
  }
  try { sessionStorage.setItem('inno_boot_seen', '1'); } catch (e) {}

  /* A RETURNING visitor gets the short version. "Once per session" isn't once for most people:
     Instagram's browser starts a fresh session every time a link is opened from the app, which
     is where most visits come from, so the full sequence played on every single visit. */
  var returning = false;
  try { returning = !!localStorage.getItem('inno_visited'); } catch (e) {}
  var QUICK = returning;
  var TOUCH = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  var SCR = '!<>-_\\/[]{}=+*^?#%&';
  var RULE = '────────────────────────────';

  /* ---- live readouts ---- */
  // the date in TORONTO, like the clock, the weather and the coordinates it sits among
  function fmtDate(d) {
    try {
      var parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Toronto', year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'short' }).formatToParts(d);
      var get = function (t) { for (var i = 0; i < parts.length; i++) if (parts[i].type === t) return parts[i].value; return ''; };
      return get('year') + '.' + get('month') + '.' + get('day') + '  ·  ' + get('weekday').replace('.', '').slice(0, 3).toUpperCase();
    } catch (e) {
      var days = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
      return d.getFullYear() + '.' + String(d.getMonth() + 1).padStart(2, '0') + '.' + String(d.getDate()).padStart(2, '0') + '  ·  ' + days[d.getDay()];
    }
  }
  var pad2 = function (n) { return String(n).padStart(2, '0'); };

  // the archive, counted from the catalogue the homepage already carries
  var PRODUCTS = window.INNO_PRODUCTS || [];
  var available = 0;
  for (var pi = 0; pi < PRODUCTS.length; pi++) if (PRODUCTS[pi] && PRODUCTS[pi].a) available++;
  var bag = parseInt(window.INNO_CART_COUNT, 10) || 0;

  var weatherText = '···';
  function fmtWeather(temp, code) {
    var map = { 0: 'CLEAR', 1: 'MOSTLY CLEAR', 2: 'PARTLY CLOUDY', 3: 'OVERCAST',
      45: 'FOG', 48: 'FOG', 51: 'DRIZZLE', 53: 'DRIZZLE', 55: 'DRIZZLE',
      61: 'RAIN', 63: 'RAIN', 65: 'HEAVY RAIN', 66: 'FREEZING RAIN', 67: 'FREEZING RAIN',
      71: 'SNOW', 73: 'SNOW', 75: 'HEAVY SNOW', 77: 'SNOW GRAINS',
      80: 'SHOWERS', 81: 'SHOWERS', 82: 'SHOWERS', 85: 'SNOW SHOWERS', 86: 'SNOW SHOWERS',
      95: 'STORM', 96: 'STORM', 99: 'STORM' };
    return Math.round(temp) + '°C · ' + (map[code] || 'CLEAR');
  }
  try {
    fetch('https://api.open-meteo.com/v1/forecast?latitude=43.6503&longitude=-79.3975&current=temperature_2m,weather_code')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || !d.current) return;
        weatherText = fmtWeather(d.current.temperature_2m, d.current.weather_code);
        var wl = document.querySelector('#inno-boot-output [data-weather]');
        if (wl && !finalized) scrambleReveal(wl, 'LOC:      YYZ · ' + weatherText);
      })
      .catch(function () {});
  } catch (e) {}

  /* ---- the sequence ---- */
  var SEQ = [];
  function line(d, t, o) { var e = o || {}; e.d = d; e.t = t; SEQ.push(e); }
  line(40, 'PROJECT: INNOCENCES');
  line(90, RULE);
  line(90, returning ? 'SESSION RESTORED' : 'SESSION ESTABLISHED', { cls: 'is-hl' });
  line(50, '');
  if (!QUICK) {
    // the same vocabulary as the Instagram bio, which is where most visitors arrive from
    line(90, 'ROOT:     @FINNS.FATE  [ VERIFIED ]');
    line(90, 'STORE:    ONLINE · BY APPOINTMENT', { cls: 'is-hl' });
    line(50, '');
    line(90, RULE);
  }
  line(100, 'USER:     ' + (returning ? '[ RETURNING ]' : '[ NEW ]'), { cls: 'is-hl' });
  if (bag > 0) line(100, 'BAG:      ' + pad2(bag) + (bag === 1 ? ' ITEM' : ' ITEMS'), { cls: 'is-hl' });
  if (PRODUCTS.length) line(100, 'ARCHIVE:  ' + PRODUCTS.length + ' PIECES  ·  ' + available + ' AVAILABLE', { cls: 'is-hl' });
  line(100, 'TONE:     [ BITTERSWEET ]', { cls: 'is-hl' });
  line(100, 'DATE:     ' + fmtDate(new Date()), { cls: 'is-hl' });
  line(100, '', { weather: true, cls: 'is-hl' });
  line(120, RULE);
  // the gyro toggle used to sit on screen as a button; it's discovered here instead — but only on
  // a device that has one. iOS gates it behind the tap; Android starts it without asking.
  var gated = typeof DeviceOrientationEvent !== 'undefined' && typeof DeviceOrientationEvent.requestPermission === 'function';
  if (TOUCH && typeof DeviceOrientationEvent !== 'undefined') {
    line(90, 'MOTION    GYRO AVAILABLE  ' + (gated ? '[ TAP TO ENABLE ]' : '[ ACTIVE ]'),
      { cls: 'is-hl' + (gated ? ' is-motion' : ''), motion: true });
    line(120, RULE);
  }

  var finalized = false;

  function scrambleReveal(el, text, done) {
    var start = performance.now();
    // The decode is the signature, so every line that scrambles still scrambles — it just
    // resolves at roughly half the old pace. This runs SERIALLY (a line waits for the one
    // above it to finish), so it, not the delays between lines, is most of the boot's length.
    var dur = 170 + text.length * 7;
    (function step(now) {
      if (finalized) { el.textContent = text; if (done) done(); return; }
      var p = (now - start) / dur;
      if (p >= 1) { el.textContent = text; if (done) done(); return; }
      var s = '';
      for (var i = 0; i < text.length; i++) {
        var c = text[i];
        if (c === ' ' || c === '·' || p * text.length * 1.6 > i) s += c;
        else s += SCR[(Math.random() * SCR.length) | 0];
      }
      el.textContent = s;
      requestAnimationFrame(step);
    })(start);
  }

  /* ---- the loading bar measures real work ----
     It used to be a 2.2s timer dressed as a progress bar. Now it waits on the things the
     homepage actually needs, weighted by how much they matter to what comes next:
       type    the site's fonts
       page    every script and stylesheet (the window load)
       field   the 3D field's first drawn frame
       archive the first shop photographs, fetched now so SHOP opens on pictures, not blanks
     The number still walks through every value on the way (a jump is a spinner in disguise),
     never finishes faster than a glance, and never waits forever on a slow photograph. */
  var WEIGHT = { type: 15, page: 35, field: 15, archive: 35 };
  var progress = { type: 0, page: 0, field: 0, archive: 0 };
  function mark(k, v) { progress[k] = Math.max(progress[k], Math.min(1, v)); }
  function target() {
    var t = 0;
    for (var k in WEIGHT) t += WEIGHT[k] * progress[k];
    return Math.round(t);
  }
  try {
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { mark('type', 1); });
    else mark('type', 1);
  } catch (e) { mark('type', 1); }
  if (document.readyState === 'complete') mark('page', 1);
  else window.addEventListener('load', function () { mark('page', 1); }, { once: true });
  if (window.__innoFieldFrame) mark('field', 1);
  else document.addEventListener('inno:field-frame', function () { mark('field', 1); }, { once: true });
  (function preloadArchive() {
    var urls = [];
    for (var i = 0; i < PRODUCTS.length && urls.length < 6; i++) if (PRODUCTS[i] && PRODUCTS[i].img) urls.push(PRODUCTS[i].img);
    if (!urls.length) { mark('archive', 1); return; }
    var done = 0;
    urls.forEach(function (u) {
      var im = new Image();
      im.onload = im.onerror = function () { done++; mark('archive', done / urls.length); };
      im.src = u;
    });
  })();

  function startExit() {
    if (finalized || boot.classList.contains('is-out')) return;
    boot.style.transition = 'opacity 0.55s ease';
    boot.classList.add('is-out');
  }
  function finalize() {
    if (finalized) return;
    finalized = true;
    try { sessionStorage.setItem('inno_booted', '1'); } catch (e) {}
    try { localStorage.setItem('inno_visited', '1'); } catch (e) {}
    document.removeEventListener('keydown', keyEnd);
    boot.removeEventListener('click', skip);
    boot.style.display = 'none';
    // out of the document, not just hidden: its lines are registered as tilt plates, and a hidden
    // element still gets written to on every gyro reading
    if (boot.parentNode) boot.parentNode.removeChild(boot);
    document.dispatchEvent(new Event('inno:reveal-ui'));
  }
  // the boot's own tap is the site's FIRST gesture — spend it on the motion prompt, so the
  // request isn't competing with the visitor's first real intent (almost always SHOP)
  function askMotion() {
    try { if (window.innoAskGyro) window.innoAskGyro(); } catch (e) {}
  }
  function skip() {
    askMotion();
    if (finalized || boot.classList.contains('is-out')) return;
    boot.style.transition = 'opacity 0.5s ease';
    boot.classList.add('is-out');
    document.dispatchEvent(new Event('inno:reveal-mesh'));
    setTimeout(finalize, 520);
  }
  function keyEnd(e) { if (e.key === 'Enter' || e.key === ' ' || e.key === 'Escape') skip(); }
  document.addEventListener('keydown', keyEnd);
  // skipping was always possible and never said so
  setTimeout(function () {
    boot.addEventListener('click', skip);
    if (hint) {
      hint.textContent = TOUCH ? '[ TAP TO SKIP ]' : '[ CLICK OR PRESS ENTER TO SKIP ]';
      hint.classList.add('is-on');
      plate(hint, 12);
    }
  }, 300);
  // ask on the first touch of the boot even when it lands too early to count as a skip,
  // and once more the moment the sequence hands over — whichever comes first
  boot.addEventListener('touchend', askMotion, { once: true, capture: true });
  document.addEventListener('inno:reveal-ui', askMotion, { once: true });

  /* ---- the readout leans with the phone ----
     Each line joins the same counter-tilt the homescreen's status block uses, at its own depth:
     further down the stack = further away = more travel. So the intro is already the gyro
     surface the site turns out to be, rather than a flat screen in front of one. */
  function plate(el, idx) {
    if (window.innoTiltPlate) window.innoTiltPlate(el, 0.35 + Math.min(1, idx / 10) * 0.75, false);
  }

  /* ---- waiting on the motion prompt ----
     iOS only hands out the permission dialog from inside a gesture, so tapping the MOTION line is
     the moment. The sequence holds while the dialog is up, and carries on the instant it's
     answered — with the field already leaning if the answer was yes. */
  var paused = false, resumeIdx = -1, resumeT = 0, motionLine = null;
  function resume() {
    paused = false;
    clearTimeout(resumeT);
    if (resumeIdx >= 0) { var i = resumeIdx; resumeIdx = -1; runLine(i); }
  }
  function hold(ms) {
    paused = true;
    clearTimeout(resumeT);
    resumeT = setTimeout(resume, ms);   // dismissed without an answer → carry on regardless
  }
  document.addEventListener('inno:motion', function (ev) {
    var granted = !!(ev.detail && ev.detail.granted);
    if (motionLine) {
      motionLine.classList.remove('is-motion');
      motionLine.removeAttribute('role');
      var txt = 'MOTION    GYRO ' + (granted ? 'ENABLED      [ ACTIVE ]' : 'AVAILABLE    [ DECLINED ]');
      if (finalized) motionLine.textContent = txt; else scrambleReveal(motionLine, txt);
    }
    resume();
  });

  // lines arrive WHOLE (line-by-line). ~40% of the real text lines decode via a character
  // scramble; rules / blanks appear instantly. The short version skips the scramble.
  var SPEED = QUICK ? 0.3 : 0.68;   // the same sequence, read at a brisker pace
  function runLine(idx) {
    if (finalized) return;
    if (paused) { resumeIdx = idx; return; }
    if (idx >= SEQ.length) { finish(); return; }
    var e = SEQ[idx];
    setTimeout(function () {
      if (finalized) return;
      var el = document.createElement('div');
      el.className = 'inno-boot-line' + (e.cls ? ' ' + e.cls : '');
      out.appendChild(el);
      plate(el, idx);
      if (e.weather) el.setAttribute('data-weather', '');
      if (e.motion) {
        motionLine = el;
        if (gated) {
          el.setAttribute('role', 'button');
          el.addEventListener('click', function (ev) {
            // the gyro, not the exit: this tap must not double as the skip
            ev.stopPropagation();
            askMotion();
            hold(5000);
          });
        }
      }
      // the weather line reads the forecast NOW, not when the sequence was built — the fetch
      // usually lands first, and a baked-in placeholder would never be replaced
      var text = e.weather ? 'LOC:      YYZ · ' + weatherText : (e.t || '');
      var scrambleable = text.replace(/[─\s]/g, '').length > 2;
      if (scrambleable && !QUICK && Math.random() < 0.4) {
        scrambleReveal(el, text, function () { runLine(idx + 1); });
      } else {
        el.textContent = text;
        runLine(idx + 1);
      }
    }, Math.round(e.d * SPEED));
  }

  // loading bar runs to 100% → ENTERING... → the boot exits, and the homescreen sequence begins
  // (wave loads in, then the UI)
  function finish() {
    if (finalized) return;
    var bar = document.createElement('div');
    bar.className = 'inno-boot-line is-hl';
    out.appendChild(bar);
    plate(bar, SEQ.length);
    var W = 22, start = Date.now();
    var MIN = QUICK ? 320 : 700;     // never over faster than it can be read
    var MAX = QUICK ? 3200 : 5000;   // and never held up by one slow photograph
    var shown = 0;
    (function tick() {
      if (finalized) return;
      var el = Date.now() - start;
      var aim = el >= MAX ? 100 : target();
      // walk toward the real figure, and no faster than the minimum run allows
      aim = Math.min(aim, Math.floor(el / MIN * 100));
      if (shown < aim) shown = Math.min(aim, shown + Math.max(1, Math.ceil((aim - shown) * 0.18)));
      var filled = Math.round(shown * W / 100);
      bar.textContent = 'LOADING [' + '█'.repeat(filled) + ' '.repeat(W - filled) + '] ' + String(shown).padStart(3) + '%';
      if (shown < 100) { setTimeout(tick, 34); return; }
      var enter = document.createElement('div');
      enter.className = 'inno-boot-line is-enter';
      enter.textContent = '> ENTERING';
      out.appendChild(enter);
      plate(enter, SEQ.length + 1);
      var dots = 0;
      var dotTimer = setInterval(function () {
        if (finalized) { clearInterval(dotTimer); return; }
        dots = (dots % 3) + 1;
        enter.textContent = '> ENTERING' + new Array(dots + 1).join('.');
      }, 280);
      // let ENTERING breathe, fade the whole boot out, THEN hand off to the homescreen
      setTimeout(function () {
        clearInterval(dotTimer);
        startExit();
        setTimeout(function () {
          document.dispatchEvent(new Event('inno:reveal-mesh'));   // wave loads in
          setTimeout(finalize, 340);                                // UI follows just after
        }, 570);   // ≈ the boot's exit fade — boot is gone before the mesh starts
      }, QUICK ? 260 : 520);
    })();
  }

  runLine(0);
})();
